import React from 'react';
import ThemeToursTemplate from './ThemeToursTemplate';

const Luxury = () => <ThemeToursTemplate theme="luxury" />;

export default Luxury;
